export const PURCHASE_TYPE = 'purchaseBrokerLight'
export const REFINANCE_TYPE = 'refinanceBrokerLight'
export const LOAN_TYPES_MAP = {
  purchase: PURCHASE_TYPE,
  refinance: REFINANCE_TYPE,
}

export const DOWN_PAYMENT_DEFAULT = 60000
export const ESTIMATED_VALUE_DEFAULT = 300000
export const HOME_VALUE_DEFAULT = 300000
export const LOAN_AMOUNT_DEFAULT = 240000

export const ZIP_CODE_DEFAULT = '95814'

export const EXCELLENT_FICO_TYPE = 'excellent'
export const SECOND_HOME_OCCUPANCY_TYPE = 'secondHome'
export const SINGLE_FAMILY_PROPERTY_TYPE = 'singleFamily'

export const APR_SORTING_OPTION = 'apr'

export const MORTGAGE_FILTER_FORM_NAME = 'mortgage-rates'
export const MORTGAGE_SORTING_FORM_NAME = 'mortgage-rates-sorting'

export const ELIGIBILITY_UUID_PURCHASE = 'eligibilityUUIDPurchase'
export const ELIGIBILITY_UUID_REFINANCE = 'eligibilityUUIDRefinance'
export const ELIGIBILITY_UUID_PURCHASE_LENDER_CENTRIC = 'eligibilityUUIDPurchaseLenderCentric'
export const ELIGIBILITY_LOAN_TYPE = 'loanType'

export const INITIAL_VALUES_BASE_KEYS = ['loanType', 'options', 'sorting', 'zipCode', 'terms']

export const FIFTEEN_YEARS_FIXED = 'fifteenYearsFixed'
export const THIRTY_YEARS_FIXED = 'thirtyYearsFixed'
export const THIRTY_YEARS_FIXED_JUMBO = 'thirtyYearsFixedJumbo'
export const FIFTEEN_YEARS_FIXED_JUMBO = 'fifteenYearsFixedJumbo'
export const FIVE_ONE_ARM = 'fiveOneARM'
export const TWENTY_YEARS_FIXED = 'twentyYearsFixed'
export const TEN_YEARS_FIXED = 'tenYearsFixed'
export const SEVEN_ONE_ARM = 'sevenOneARM'
export const TEN_ONE_ARM = 'tenOneARM'

export const DEFAULT_TERMS_ARR = [THIRTY_YEARS_FIXED, FIFTEEN_YEARS_FIXED]
export const TERMS_LIMIT = 4
export const CASH_OUT_LIMIT_INDEX = 0.8
export const LOAN_TERM_MODAL_NAME = 'loan-term'
export const LOAN_TYPE_MODAL_NAME = 'loan-type'

export const CONVENTIONAL_LOAN_TYPE_FILTER_VALUE = 'Conventional'
export const FHA_LOAN_TYPE_FILTER_VALUE = 'FHA'
export const CONFORMING_LOAN_TYPE = 'conforming'
export const NON_CONFORMING_LOAN_TYPE = 'nonConforming'
export const FHA_LOAN_TYPE = 'fha'

export const defaultProducts = [
  {
    __typename: 'MortgageWidgetProductType',
    discount: '2.580',
    uuid: '5e81ca34-0b1e-409e-a317-009610cbddc2',
    externalProductId: 55793299,
    lender: {
      __typename: 'MortgageLender',
      name: 'Homepoint',
      nmls: 7706,
      slug: 'homepoint',
    },
    monthlyPayment: 1192.079,
    productType: 'thirtyYearsFixed',
    loanTerm: 30,
    amortizationType: 'Fixed',
    rate: 4.25,
    apr: 4.527,
    fees: 7796.9076000000005,
    bestProduct: true,
  },
  {
    __typename: 'MortgageWidgetProductType',
    discount: '2.009',
    uuid: '7dde0bb3-c45e-4d33-bd58-05e5885cc8a2',
    externalProductId: 55793299,
    lender: {
      __typename: 'MortgageLender',
      name: 'Homepoint',
      nmls: 7706,
      slug: 'homepoint',
    },
    monthlyPayment: 1209.878,
    productType: 'thirtyYearsFixed',
    loanTerm: 30,
    amortizationType: 'Fixed',
    rate: 4.375,
    apr: 4.604,
    fees: 6413.24898,
    bestProduct: true,
  },
  {
    __typename: 'MortgageWidgetProductType',
    discount: '2.435',
    uuid: '60bd60f7-34ca-49f6-ac08-3a7da6c1b610',
    externalProductId: 25565153,
    lender: {
      __typename: 'MortgageLender',
      name: 'LoanDepot',
      nmls: 174457,
      slug: 'loan_depot',
    },
    monthlyPayment: 1209.878,
    productType: 'thirtyYearsFixed',
    loanTerm: 30,
    amortizationType: 'Fixed',
    rate: 4.375,
    apr: 4.65,
    fees: 7423.5407000000005,
    bestProduct: false,
  },
]
